/**
 * 短信接口
 */
import http from './http.js';

export default class SmsAPI {
    static sendPhoneCode(params) {
        return http.httpGet('sms/create', params);
    }
}


// WEBPACK FOOTER //
// ./app/api/sms.api.js